// Bandeau : hors connexion, et rapports journaliers en attente d'envoi (saisis sans réseau sur cet appareil).
import React, { useEffect, useState } from 'react';
import { Alert, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { CloudOffOutlined } from '@mui/icons-material';
import { demarrerSynchro, envoyerFile, lireFile, onFileChange, reessayer, supprimerRapport } from '../utils/horsLigne';

const EtatConnexion = () => {
  const [enLigne, setEnLigne] = useState(navigator.onLine);
  const [file, setFile] = useState(lireFile());
  const [ouvert, setOuvert] = useState(false);
  const [info, setInfo] = useState('');
  const { pathname } = useLocation();
  useEffect(() => {
    demarrerSynchro();
    const maj = () => setFile(lireFile());
    const on = () => setEnLigne(true); const off = () => setEnLigne(false);
    window.addEventListener('online', on); window.addEventListener('offline', off);
    const stop = onFileChange(maj);
    return () => { window.removeEventListener('online', on); window.removeEventListener('offline', off); stop(); };
  }, []);
  const envoyer = async () => {
    const r = await envoyerFile();
    if (r) setInfo(r.envoyes ? `${r.envoyes} rapport(s) envoyé(s)` : r.restants ? 'Envoi impossible pour l\'instant' : '');
  };
  if (enLigne && !file.length) return null;
  // Poste de garde : il a son propre bandeau (passages en attente) ; celui-ci ne sert qu'aux rapports journaliers
  if (pathname.startsWith('/garde') && !file.length) return null;
  const refuses = file.filter((r) => r.erreur);
  return (
    <>
      <Alert className="no-print" severity={!enLigne ? 'warning' : refuses.length ? 'error' : 'info'} icon={!enLigne ? <CloudOffOutlined /> : undefined} sx={{ mb: 2 }}
        action={file.length > 0 && <>
          {enLigne && file.some((r) => !r.erreur) && <Button color="inherit" size="small" onClick={envoyer}>Envoyer</Button>}
          <Button color="inherit" size="small" onClick={() => setOuvert(true)}>Voir</Button>
        </>}>
        {!enLigne ? 'Hors connexion : vous pouvez saisir le rapport journalier, il sera envoyé au retour du réseau. ' : ''}
        {file.length > 0 ? `${file.length} rapport(s) en attente d'envoi sur cet appareil${refuses.length ? `, dont ${refuses.length} refusé(s) par le serveur` : ''}.` : ''}
        {info && ` ${info}.`}
      </Alert>
      <Dialog open={ouvert} onClose={() => setOuvert(false)} fullWidth maxWidth="sm">
        <DialogTitle>Rapports en attente sur cet appareil</DialogTitle>
        <DialogContent dividers>
          {file.map((r) => (
            <Box key={r.id} sx={{ mb: 1.5, pb: 1.5, borderBottom: '1px solid', borderColor: 'divider' }}>
              <Typography sx={{ fontWeight: 600 }}>Rapport du {String(r.payload?.report_date || '').split('-').reverse().join('/')} — {[r.payload?.employee_firstname, r.payload?.employee_name].filter(Boolean).join(' ')}</Typography>
              <Typography sx={{ fontSize: 12.5, color: 'text.secondary' }}>Saisi le {new Date(r.cree_le).toLocaleString('fr-FR')} · {Object.values(r.payload?.pba_produced || {}).reduce((s, q) => s + (Number(q) || 0), 0)} poteau(x)</Typography>
              {r.erreur && <Alert severity="error" sx={{ mt: 1 }}>{r.erreur}</Alert>}
              <Box sx={{ mt: 1, display: 'flex', gap: 1 }}>
                {r.erreur && <Button size="small" onClick={() => reessayer(r.id)}>Réessayer</Button>}
                <Button size="small" color="error" onClick={() => { if (window.confirm('Supprimer ce rapport de l\'appareil ? Il ne sera pas envoyé.')) supprimerRapport(r.id); }}>Supprimer</Button>
              </Box>
            </Box>
          ))}
          {!file.length && <Typography sx={{ color: 'text.secondary' }}>Aucun rapport en attente.</Typography>}
        </DialogContent>
        <DialogActions><Button onClick={() => setOuvert(false)}>Fermer</Button></DialogActions>
      </Dialog>
    </>
  );
};

export default EtatConnexion;
